var _path, _g, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_414_10313",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.857422 0.396484H14.6356V16.3209H0.857422V0.396484Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_414_10313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5207 2.12196H11.2268V1.79423C11.2268 1.0257 10.6019 0.400391 9.83374 0.400391H5.64799C4.87984 0.400391 4.25491 1.0257 4.25491 1.79423V2.12196H1.96102C1.36009 2.12196 0.871094 2.61115 0.871094 3.21246V3.72949C0.871094 4.29221 1.29942 4.75682 1.84698 4.81404L2.96935 14.6689C3.07629 15.61 3.87112 16.3196 4.81801 16.3196H10.6635C11.6102 16.3196 12.4052 15.61 12.5122 14.6689L13.6346 4.81404C14.1821 4.75702 14.6104 4.29221 14.6104 3.72949V3.21246C14.6104 2.61115 14.1214 2.12196 13.5205 2.12196H13.5207ZM4.96239 1.79423C4.96239 1.41582 5.26996 1.10806 5.64818 1.10806H9.83374C10.2122 1.10806 10.5195 1.41582 10.5195 1.79423V2.12196H4.96239V1.79423ZM11.8097 14.5886C11.7433 15.1721 11.2506 15.6119 10.6639 15.6119H4.81821C4.23149 15.6119 3.73884 15.1721 3.67261 14.5886L2.56003 4.82018H12.9223L11.8097 14.5886ZM13.9035 3.72949C13.9035 3.94049 13.7317 4.11232 13.5209 4.11232H1.96102C1.75002 4.11232 1.57838 3.94049 1.57838 3.72949V3.21246C1.57838 3.00146 1.75002 2.82963 1.96102 2.82963H13.5205C13.7315 2.82963 13.9032 3.00146 13.9032 3.21246V3.72949H13.9035Z",
    fill: "#FF5151"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.73939 13.6934C7.93464 13.6934 8.09303 13.535 8.09303 13.3395V7.08626C8.09303 6.89101 7.93464 6.73242 7.73939 6.73242C7.54413 6.73242 7.38574 6.89101 7.38574 7.08626V13.3395C7.38574 13.535 7.54413 13.6934 7.73939 13.6934Z",
    fill: "#FF5151"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8546 13.6782C9.86631 13.6794 9.87802 13.68 9.88935 13.68C10.0692 13.68 10.2232 13.5433 10.2409 13.3605L10.8466 7.13638C10.8656 6.9419 10.7234 6.76872 10.5291 6.74991C10.3319 6.72994 10.1616 6.87316 10.1426 7.06765L9.53686 13.2916C9.51785 13.4862 9.66012 13.6592 9.85441 13.6782H9.8546Z",
    fill: "#FF5151"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59099 13.68C5.60232 13.68 5.61403 13.6794 5.62574 13.6782C5.82003 13.6594 5.96211 13.4862 5.94329 13.2916L5.33737 7.06765C5.31856 6.87316 5.14826 6.72994 4.95109 6.74991C4.7568 6.76853 4.61453 6.9419 4.63354 7.13638L5.23927 13.3605C5.25712 13.5433 5.4109 13.68 5.5908 13.68H5.59099Z",
    fill: "#FF5151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.3e9d3ef683e521668b6628db31d71ae0.svg";
export { ForwardRef as ReactComponent };